import { SET_WORKOUT_PLANS, SET_WORKOUT_PLAN_BY_ID, RESET_WORKOUT_PLAN_BY_ID, RESET_WORKOUT_PLANS } from './workoutPlanTypes';

const initialState = {
	customerPlans: [],
	currentPlan: null,
	loading: false,
};

export const workoutPlanReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_WORKOUT_PLANS:
			return { ...state, customerPlans: action.payload };
		case SET_WORKOUT_PLAN_BY_ID:
			return { ...state, currentPlan: action.payload };
		case RESET_WORKOUT_PLAN_BY_ID:
			return { ...state, currentPlan: null };
		case RESET_WORKOUT_PLANS:
			return { ...state, customerPlans: [] };
		default:
			return state;
	}
};
